import React from 'react';
import { ContestSeason, Show, Phase } from '../../types';

interface ShowCountdownProps {
  show: Show;
  currentPhase?: Phase;
  countdown: {
    weeksRemaining: number;
    daysRemaining: number;
    phaseWeek: number;
  };
  /** When provided, shows the real season name instead of the static "Active Season" label. */
  activeSeason?: ContestSeason;
}

const ShowCountdown: React.FC<ShowCountdownProps> = ({ show, currentPhase, countdown, activeSeason }) => {
  const seasonLabel = activeSeason?.name ?? 'Active Season';

  return (
    <div className="bg-dark-800 border-t-2 border-gold-500 py-6 px-8">
      {/* Season Label */}
      <div className="text-center mb-4">
        <h2 className="text-xl font-bold text-white tracking-wide">
          {seasonLabel}
        </h2>
      </div>

      {/* Primary Show Section */}
      <div className="text-center mb-6">
        <div className="flex items-center justify-center gap-2 mb-1">
          <span className="text-gold-500 text-2xl">🏆</span>
          <h1 className="text-2xl font-bold text-gold-500">{show.name}</h1>
        </div>
        <div className="text-xs uppercase tracking-wider text-gray-500 mb-1">
          Primary Show
        </div>
        <div className="text-gray-400 text-sm">
          {show.location} · {show.category}{show.division ? ` · ${show.division}` : ''}
        </div>
      </div>

      {/* Countdown Boxes — unchanged */}
      <div className="flex justify-center items-center gap-6">
        {/* Weeks */}
        <div className="gradient-border px-8 py-6 text-center min-w-[120px]">
          <div className="text-5xl font-bold text-gold-500 mb-2">
            {countdown.weeksRemaining}
          </div>
          <div className="text-xs uppercase tracking-wider text-gray-400">
            WEEKS
          </div>
        </div>

        {/* Days */}
        <div className="gradient-border px-8 py-6 text-center min-w-[120px]">
          <div className="text-5xl font-bold text-gold-500 mb-2">
            {countdown.daysRemaining}
          </div>
          <div className="text-xs uppercase tracking-wider text-gray-400">
            DAYS
          </div>
        </div>

        {/* Phase Week */}
        <div className="gradient-border px-8 py-6 text-center min-w-[120px]">
          <div className="text-5xl font-bold text-gold-500 mb-2">
            {countdown.phaseWeek}
          </div>
          <div className="text-xs uppercase tracking-wider text-gray-400">
            PHASE WEEK
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowCountdown;
